// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   HSId: "6638043",
//   formLinkConlea: "https://dev.signup.conlea.pl/",
//   formLinkLMIT: "https://dev.signup.conlea.pl/",
//   formNonameTicketsConlea: "https://dev.signup.conlea.pl/no-name-tickets/",
//   formNonameTicketsLmit: "https://dev.signup.conlea.pl/no-name-tickets/",
//   // formNonameTicketsLmit: 'https://join.letsmanageit.pl/no-name-tickets/',
//   // formLink: 'http://localhost:3000/',

//   APIEndpoint: "https://devapiconlea.herokuapp.com/",

//   // APIEndpoint: "https://apiconlea.herokuapp.com/",
//   // APIEndpoint: 'http://127.0.0.1:3333/',
// };

export const environment = {
  production: true,
  HSId: "6542241",
  formLinkConlea: "https://signup.conlea.pl/",
  formLinkLMIT: "https://join.letsmanageit.pl/",
  formNonameTicketsConlea: "https://signup.conlea.pl/no-name-tickets/",
  formNonameTicketsLmit: "https://join.letsmanageit.pl/no-name-tickets/",
  APIEndpoint: "https://api.conlea.pl/",
  // APIEndpoint: "https://devapiconlea.herokuapp.com/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
